module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescirp7-cb6759fc50f1e96905877bf985e55413.jpg";